// Generated by CoffeeScript 2.7.0
var FlowMoreOperations;

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

export default FlowMoreOperations = {
  beforeAction: function(action) {
    this._initOperationsPopover();
    this._initSharePopover();
    return this._initNavMenuPopover();
  },
  _initOperationsPopover: function() {
    var flow_id, operation_popover_el;
    operation_popover_el = DomMaster.find('.flow-more-operations-popover');
    if (!operation_popover_el.isPresent()) {
      return;
    }
    new Skylark.Elements.Popover(operation_popover_el, {
      size: 'small'
    });
    flow_id = location.pathname.match(/flows\/(\d+)/)[1];
    this._doArchiveFlow(operation_popover_el, flow_id);
    return this._doRepairFlow(operation_popover_el, flow_id);
  },
  _doArchiveFlow: function(el, flow_id) {
    return el.node.proxy('click', '.js-archive-flow', function(event) {
      return newConfirm({
        icon: '<i class="slp-warning-circle"></i>',
        title: "删除流程",
        message: '当前流程及其所有数据都将被删除，此操作不可撤销',
        confirmButtonText: '删除',
        type: "danger"
      }).$on('ensureClicked', function() {
        return Skylark.Libs.Ajax.patch(`/admin/yet_another_workflow/flows/${flow_id}/archive`, {
          responseType: 'script'
        });
      });
    });
  },
  _initSharePopover: function() {
    return new Skylark.Elements.SharePopover(DomMaster.find('.share-popover'));
  },
  _initNavMenuPopover: function() {
    // 获取指定dom，实例化一个popover并返回
    return new Skylark.Elements.Popover(DomMaster.find('.nav-menu-popover'), {
      size: 'larger',
      type: 'prompt'
    });
  }
};
